
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0e296fa4&scoped=true!../css/modalHistoricoNotificacao.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalHistoricoNotificacao.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0e296fa4!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalHistoricoNotificacao.vue"),
  /* scopeId */
  "data-v-0e296fa4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/notificacao/modal/ModalHistoricoNotificacao.vue
// module id = 908
// module chunks = 1